/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconPlaySolid from '@telus-uds/palette-allium/build/rn/icons/PlaySolid'
const theme = {
  appearances: {
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: { buttonContentChildrenBackground: 'rgba(0, 0, 0, 0.8)' }
    }
  ],
  tokens: {
    buttonContentBackground: 'rgba(0, 0, 0, 0.6)',
    buttonContentChildrenBackground: null,
    playIcon: PaletteIconPlaySolid,
    playIconColor: '#ffffff'
  }
}
export default theme
